import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from "react-country-flag";
import ApiClient from "../services/api-client"
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import logo from '../img/timologic_login.png';
import '../styles/login-register-layout.css';

function ForgotPasswordForm() {
    const [email, setEmail] = useState("");
    const { t } = useTranslation();

    const handleSubmit = (event) => {
        event.preventDefault();
        ApiClient.resetPassword(email).then(
            () => toast.success(t("lookUpEmail", { email: email })),
            (error) => toast.error(error.response?.data?.message || error.message)
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="alert alert-info" role="alert"
                style={{ fontSize: '0.88rem', borderRadius: 10, marginBottom: 18 }}>
                {t("ResetEmailMess")}
            </div>
            <div className="login-form-item">
                <input type="email" name="email"
                    className="form-control" placeholder="Email"
                    value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <hr />
            <button type="submit" className="btn btn-block btn-skin">{t("ResetEmail")}</button>
        </form>
    );
}

export default function ForgotPassword() {
    const { t, i18n } = useTranslation();

    const changeLang = (e, lang) => {
        e.preventDefault();
        i18n.changeLanguage(lang.toLowerCase());
    };

    return (
        <div className="llr-page">
            <div className="llr-card">
                <div className="llr-header">
                    <img src={logo} alt="Timologic" className="llr-logo" />
                </div>
                <div className="llr-body">
                    <ForgotPasswordForm />
                    <div className="login-link" style={{ marginTop: 14 }}>
                        <Link to="/login">← {t("Back")}</Link>
                    </div>
                </div>
                <div className="llr-footer" style={{ justifyContent: 'flex-end' }}>
                    <div className="llr-flags">
                        <a href="#" onClick={(e) => changeLang(e, "GB")}>
                            <ReactCountryFlag countryCode="GB" svg style={{ fontSize: '1.6em' }} />
                        </a>
                        <a href="#" onClick={(e) => changeLang(e, "GR")}>
                            <ReactCountryFlag countryCode="GR" svg style={{ fontSize: '1.6em' }} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
